import '../features/mainProduct/scripts';
import '../features/brands/scripts';
import '../features/giftwrap/scripts/';
import '../features/mixMatch/scripts';
import '../features/scalePoint/scripts/';
import '../features/personalCard/scripts';
import '../features/singlePairSelector/scripts';
import '../features/store-availability/scripts';
import '../features/shippingCountdown/scripts';
import '../features/variantPicker/scripts';
import '../features/clerkSearch/scripts';
import '../features/cartAttributes/scripts';